"use strict";

var _objectSpread = require("C:\\Users\\mhatr\\OneDrive\\Desktop\\Dean Work\\decimal-factor-us-ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");
var _objectWithoutProperties = require("C:\\Users\\mhatr\\OneDrive\\Desktop\\Dean Work\\decimal-factor-us-ca\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectWithoutProperties");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.type = type;
var _dom = require("@testing-library/dom");
var _typeImplementation = require("./typeImplementation");

// this needs to be wrapped in the event/asyncWrapper for React's act and angular's change detection
// depending on whether it will be async.
function type(element, text) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    options = _objectWithoutProperties(_ref, ["delay"]);
  // we do not want to wrap in the asyncWrapper if we're not
  // going to actually be doing anything async, so we only wrap
  // if the delay is greater than 0
  if (delay > 0) {
    return (0, _dom.getConfig)().asyncWrapper(function () {
      return (0, _typeImplementation.typeImplementation)(element, text, _objectSpread({
        delay: delay
      }, options));
    });
  } else {
    return void (0, _typeImplementation.typeImplementation)(element, text, _objectSpread({
      delay: delay
    }, options)) // prevents users from dealing with UnhandledPromiseRejectionWarning
    .catch(console.error);
  }
}